import { c as _c } from "react/compiler-runtime";
import { TooltipTrigger as RAC_TooltipTrigger } from 'react-aria-components';
import type { TooltipTriggerProps } from './Tooltip.types';
function TooltipTrigger(t0) {
  const $ = _c(10);
  let children;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      children,
      delay: t1,
      closeDelay: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
  } else {
    children = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const delay = t1 === undefined ? 150 : t1;
  const closeDelay = t2 === undefined ? 150 : t2;
  let t3;
  if ($[5] !== children || $[6] !== closeDelay || $[7] !== delay || $[8] !== props) {
    t3 = <RAC_TooltipTrigger delay={delay} closeDelay={closeDelay} {...props}>{children}</RAC_TooltipTrigger>;
    $[5] = children;
    $[6] = closeDelay;
    $[7] = delay;
    $[8] = props;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
export { TooltipTrigger };